import React, { useState } from 'react';
import _ from 'lodash';
import UserData from './UserData';
import ChangePassword from './ChangePassword';
import { useUser } from '../../../../contexts/user.context';
import { useForm } from 'react-hook-form';
import SaveButton from '../../../../components/SaveButton';
import { mobilizeiUsersService } from '../../../../services/mobilizei/users.service';
import { showApiError } from '../../../../utils/errors';
import { toast } from 'react-toastify';
import { formatPhoneNumber, parsePhoneNumber } from '../../../../utils/countries';

export default function General() {
    const { user, setUser } = useUser();

    const [isLoading, setIsLoading] = useState(false);

    // The number is stored in E.164, but the field edits the country and the
    // national number separately.
    const { countryCode, nationalNumber } = parsePhoneNumber(user?.phoneNumber);

    const { control, handleSubmit, watch, reset, register, formState: { errors, isDirty } } = useForm({
        defaultValues: {
            name: user?.name,
            email: user?.email,
            phoneCountryCode: countryCode,
            phoneNumber: nationalNumber,
            currentPassword: '',
            password: '',
            passwordConfirmation: '',
        }
    });

    const onSubmit = (data) => {
        if (!data) {
            return
        }

        setIsLoading(true)

        // The country code is only a helper for the phone field: it is never
        // sent on its own, it is joined into the E.164 number below.
        const { phoneCountryCode, ...formData } = data;

        // Remove empty properties
        let dataToPost = _.omitBy(formData, _.isEmpty);

        // Format phone number
        if (dataToPost.phoneNumber) {
            dataToPost.phoneNumber = formatPhoneNumber(phoneCountryCode, dataToPost.phoneNumber);
        }

        mobilizeiUsersService.updateUserData(dataToPost).then(() => {
            toast.success('Alterações salvas com sucesso!');

            const newData = {
                name: data.name,
                email: data.email,
                phoneCountryCode: data.phoneCountryCode,
                phoneNumber: data.phoneNumber,
                currentPassword: '',
                password: '',
                passwordConfirmation: '',
            }

            // Update the local user data to match the data that was updated on
            // the backend. The country code stays out of it: the user keeps the
            // number in E.164, as the API returns it.
            const { phoneCountryCode: _countryCode, ...newUserData } = newData;
            setUser({
                ...user,
                ...newUserData,
                phoneNumber: formatPhoneNumber(data.phoneCountryCode, data.phoneNumber)
            });

            // Calling the reset function with an object will update the form defaultValues 
            // and subsequent calls to reset() will use the new default values
            reset(newData);
        })
            .catch(e => {
                showApiError(e.error);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    return (
        <>
            <UserData
                control={control}
                register={register}
                errors={errors}
            />
            <ChangePassword
                watch={watch}
                register={register}
                errors={errors}
            />
            <SaveButton
                isLoading={isLoading}
                onCancel={() => reset()}
                show={isDirty}
                onClick={handleSubmit(onSubmit)}
            />
        </>
    );
}